<template>
    <div>
        <!--新增 Car Plate 弹框-->
        <el-dialog :title="$t('AddCarPlate')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="addCarPlate.addCarPlateFrom" 
            center 
            :show-close="addCarPlate.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('Name') + ' *'">
                                    <el-input  v-model="addCarPlate.title"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('CarPlateNumber') + ' *'">
                                    <el-input style="width: 90%;"  v-model="addCarPlate.carPlate"></el-input>
                                </el-form-item>
                            </div>
                            
                        </div>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('ParkingCardNumber') + ' *'">
                                    <el-input v-model="addCarPlate.payload"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select v-model="addCarPlate.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in addCarPlate.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input v-model="addCarPlate.countLimit" :disabled="addCarPlate.countLimitDis"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    @change="addCarPlateUnlinmitChage"
                                    v-model="addCarPlate.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        :disabled="addCarPlate.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addCarPlate.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        :disabled="addCarPlate.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addCarPlate.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            @change="addCarPlateForeverChage"
                                            v-model="addCarPlate.fovever">
                                        </el-switch>
                                    </el-form-item>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in addCarPlate.devList" :key="item.id" style="margin-bottom: 5px">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="addCarPlate.addCarPlateFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="addCarPlate.addBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="addCarPlateSave">{{$t('Confirm')}}</el-button>
            </div>
        </el-dialog>
        <!--编辑 Car Plate 弹框-->
        <el-dialog :title="$t('EditCarPlate')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="editCarPlate.editCarPlateFrom" 
            center 
            :show-close="editCarPlate.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('Name')  + ' *'">
                                    <el-input v-model="editCarPlate.title"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('CarPlateNumber') + ' *'">
                                    <el-input disabled v-model="editCarPlate.carPlate"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('ParkingCardNumber') + ' *'">
                                <el-input disabled v-model="editCarPlate.payload"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select disabled v-model="editCarPlate.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in editCarPlate.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                            </el-form-item>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input  v-model="editCarPlate.countLimit" disabled></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    disabled
                                    @change="editCarPlateUnlinmitChage"
                                    v-model="editCarPlate.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        disabled
                                        style="width: 46%; font-size:14px;"
                                        v-model="editCarPlate.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        disabled
                                        style="width: 46%;font-size:14px;"
                                        v-model="editCarPlate.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            @change="editCarPlateForeverChage"
                                            disabled
                                            v-model="editCarPlate.fovever">
                                        </el-switch>
                                    </el-form-item>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in editCarPlate.devList" :key="item.id" style="margin-bottom: 5px;display:flex;justify-content: space-between;">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                            <div v-show="item.isChecked" style="color:#999;font-size:14px;">{{handPanelApplyStatus(item.applyStatus)}}</div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="editCarPlate.editCarPlateFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="editCarPlate.editBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="editCarPlateSave">{{$t('Confirm')}}</el-button>
            </div>
        </el-dialog>
        <!--删除 Car Plate 弹框-->
        <el-dialog
            :title="$t('Delete')"
            :visible.sync="delCarPlate.delCarPlateFrom"
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            width="500px"
            :show-close="delCarPlate.showClose">
            <p class="deleteDesc">{{$t('ConfirmDeleteCarPlate')}}</p>
            <span slot="footer" class="dialog-footer addCard">
                <el-button @click="delCarPlate.delCarPlateFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" class="selectBtn" style="margin-left: 60px !important" :loading="delCarPlate.delBtnState === 1" @click="delCarPlateSetting">{{$t('Confirm')}}</el-button>
            </span>
        </el-dialog>
        <div class="noSipsettings" v-show="carPlate.hasNoCarPlate">{{$t('NoData')}}!</div>
        <template>
            <el-table
            v-show="!carPlate.hasNoCarPlate"
            :data="carPlate.passwordList"
            style="width: 100%;"
            :header-cell-style="{background:'#EDEFFB',color:'#4D4D4F'}"
            >
                <el-table-column
                    label="#"
                    type="index"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="title"
                    :label="$t('Name')"
                    >
                </el-table-column>
                
                <el-table-column
                    prop="payload"
                    :label="$t('ParkingCardNumber')"
                    >
                    <template slot-scope="scope">
                        {{decryptPasswordUnlock(scope.row.payload)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="carPlate"
                    :label="$t('CarPlateNumber')"
                    >
                    <template slot-scope="scope">
                        {{decryptPasswordUnlock(scope.row.carPlate)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="countLimit"
                    :label="$t('LimitedUse')"
                    >
                    <template slot-scope="scope">
                        {{handCountLimit(scope.row.countLimit,scope.row.usedCount)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="startTime"
                    :label="$t('ValidityTime')"
                    >
                    <template slot-scope="scope">
                        {{validityTime(scope.row.startTime,scope.row.endTime)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="entranceDeviceIds"
                    :label="$t('PanelSync')"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        {{showPanelsName(scope.row.entranceDeviceIds)}}
                    </template>
                </el-table-column>
                <el-table-column width="150"  label="..." align="center">
                    <template slot-scope="scope">
                        <el-image :src="carPlate.editImg" :title="$t('Edit')"  @click="editCarPlateSetting(scope.row)" style="width:24px;" fit="fill"></el-image>
                        <el-image :src="carPlate.deleteImg" :title="$t('Delete')"  @click="openDelCarPlateFrom(scope.row)" style="width:24px;margin-left:1vw" fit="fill"></el-image>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
  
</template>

<script>
import CryptoJS from 'crypto-js';
import { encryptCBC, decryptCBC } from "@/util/aes";
import { mapState } from 'vuex';
import sitesUsersApi from '@/api/siteusers/index.js'
import editImg from '@/assets/images/edit.png'
import deleteImg from '@/assets/images/delete.png'
export default {
    name:"CarPlate",
    data(){
        return{
            updateSiteUser:{
                id:"",
                userId:"",
            },
            carPlate:{
                hasNoCarPlate:false,
                passwordList:[],
                editImg,
                deleteImg,
            },
            addCarPlate:{
                addCarPlateFrom:false,
                showClose:true,
                title:"",
                carPlate:"",
                payload:"",
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:"",
                Unlinmited:false,
                devList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                addBtnState:0,
            },
            editCarPlate:{
                editCarPlateFrom:false,
                showClose:true,
                entranceKeyId:"",
                title:"",
                carPlate:"",
                payload:"",
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:1,
                Unlinmited:false,
                devList:[],
                entranceDeviceList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                userId:"",
                cardNumber:"",
                editBtnState:0,
            },
            delCarPlate:{
                delCarPlateFrom:false,
                showClose:true,
                entranceKeyId:"",
                delBtnState:0,
            },
        }
    },
    mounted(){
       this.updateSiteUser.id = this.$route.params.id;
       this.updateSiteUser.userId = this.$route.params.userId;
    //    console.log("this.$route.params",this.$route.params,this.updateSiteUser.id);
       this.getSiteUserCarPlateDevicesList();
       this.getSiteUserCarPlateList();
    },
    methods:{
        //10进制转为16进制
        decimalToHex(decimal) {
            return decimal.toString(16).toUpperCase();
        },
        //16进制转为10进制
        hexToDecimal(hexString) {
            return parseInt(hexString, 16);
        },
        //base64转为16进制字符串
        base64ToHex(base64String) {
            // 解码Base64字符串
            const byteArray = atob(base64String)
                .split('')
                .map(char => char.charCodeAt(0));
            
            // 转换为16进制字符串
            return byteArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
        },
        //字符串前面补0，直到满足长度要求
        padStringToLength(str, desiredLength) {
            return str.padStart(desiredLength, '0');
        },
        //字节数组转为16进制字符串
        byteToHex(arr) {
            let hexStr = "";
            for (let i = 0; i < arr.length; i++) {
                let hex = arr[i].toString(16);
                if (hex.length === 1) {
                hex = "0" + hex;
                }
                hexStr += hex;
            }
            return hexStr;
        },
        //16进制转base64
        hexStringToBase64(hexString) {
            // 将16进制字符串转换为Uint8Array
            const byteArray = new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
            
            // 使用btoa将二进制数据转换为Base64字符串
            const base64String = btoa(String.fromCharCode(...byteArray));
            
            return base64String;
        },
        //HmacSHA1签名函数
        Hmacstr(sigstr, key) {
            let result = CryptoJS.HmacSHA1(sigstr, key);
            let sig = result.toString(CryptoJS.enc.Hex);
            return sig;
        },
        //查询住宅有权限设备列表
        getSiteUserCarPlateDevicesList(){
            let devicesInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "siteId":this.selectSite.id,
                "userHouseId":this.updateSiteUser.id,
                "pageSize":-1,
                "pageNum":1,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getSiteUserDevicesList(devicesInfoObj).then(res => {
                if(res.code === 0){
                    this.addCarPlate.devList = [];
                    this.editCarPlate.devList = [];
                    if(res.data === null || res.data.list.length === 0){
                        this.addCarPlate.devList = [];
                        this.editCarPlate.devList = [];
                    }else{
                        res.data.list.forEach(item => {
                            if(item.accessStatus === 1 && this.$getBit(this.$base64ToByteArray(item.entranceAbility), 8) === 1){
                                item.isChecked = false;
                                this.addCarPlate.devList.push(item);
                                this.editCarPlate.devList.push(item);
                            }
                            
                        })
                    }
                }else{
                    this.addCarPlate.devList = [];
                    this.editCarPlate.devList = [];
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.addCarPlate.devList = [];
                this.editCarPlate.devList = [];
                // console.log(err);
            })
        },
        //查询用户Car Plate列表
        getSiteUserCarPlateList(){
            let passwordInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let passwordPostObj = {
                "userHouseId":this.updateSiteUser.id,
                "userId":this.updateSiteUser.userId,
                "type":5,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getSiteUserCardConfigList(passwordInfoObj,passwordPostObj).then(res => {
                if(res.code === 0){
                    this.carPlate.passwordList = [];
                    if(res.data === null || res.data.length === 0){
                        this.carPlate.passwordList = [];
                        this.carPlate.hasNoCarPlate = true;
                    }else{
                        this.carPlate.hasNoCarPlate = false;
                        for(let i=0;i<res.data.length;i++){
                            this.carPlate.passwordList.push(res.data[i]);
                        }
                    }
                }else{
                    this.carPlate.passwordList = [];
                    this.carPlate.hasNoCarPlate = true;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.carPlate.passwordList = [];
                this.carPlate.hasNoCarPlate = true;
                // console.log(err);
            })
        },
         //解密密码
         decryptPasswordUnlock(cardVal){
            if(cardVal === null || cardVal === undefined || cardVal === ""){
                return ''
            }
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            //把获取到的16进制的字符串转为base64
            let base64Str = this.hexStringToBase64(cardVal);
            //解密之后得到16进制的车牌号
            let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            return cardNumHex
        },
        //处理次数
        handCountLimit(count,usedCount){
            let countLimitStr = "";
            if(count === 0){
                countLimitStr = this.$t('Unlinmited');
            }else{
                countLimitStr = usedCount + "/" + count;
            }
            return countLimitStr
        },
        //处理有效期
        validityTime(start,end){
            let validityStr = "";
            if(start === 0 && end === 0){
                validityStr = this.$t('Forever');
            }else{
                validityStr = this.utctolocal(start) + " ~ " + this.utctolocal(end);
            }
            return validityStr
        },
         //panels 名称显示
         showPanelsName(panelList){
            let panelStr = "";
            if(this.addCarPlate.devList.length != 0){
                this.addCarPlate.devList.map(item =>{
                    panelList.map(item2 =>{
                        if(item.id === item2){
                            panelStr += item.deviceName +  "\u2003"
                        }
                    })
                })
            }
            return panelStr;
        },
         //处理设备应用状态函数
         handPanelApplyStatus(statu){
            let statuStr = "";
           switch (statu) {
            case 0:
                statuStr = this.$t('NotApplied');
                break;
            case 1:
                statuStr = this.$t('ApplicationComplete');
                break;
            case 2:
                statuStr = this.$t('DataValidationFailed');
                break;
            case 3:
                statuStr = this.$t('TypesNotSupported');
                break;
            case 4:
                statuStr = this.$t('DeviceLimitedInput');
                break;
            case 5:
                statuStr = this.$t('DeviceDataDuplication');
                break;
            default:
                statuStr = "";
           }
            return statuStr
        },
        addCarPlateSetting(){
            this.addCarPlate.addCarPlateFrom = true;
            this.addCarPlate.title = "";
            this.addCarPlate.carPlate = "";
            this.addCarPlate.payload = "";
            this.addCarPlate.locks = "";
            this.addCarPlate.countLimit = "";
            this.addCarPlate.countLimitDis = false;
            this.addCarPlate.Unlinmited = false;
            this.addCarPlate.startTime = "";
            this.addCarPlate.endTime = "";
            this.addCarPlate.isFovever = false;
            this.addCarPlate.fovever = false;
            this.addCarPlate.devList.map(item =>{
                item.isChecked = false;
            })
        },
        //添加Car Plate 不限次数开关改变函数
        addCarPlateUnlinmitChage(item){
            if(item){
                this.addCarPlate.countLimit = "";
                this.addCarPlate.countLimitDis = true;
            }else{
                this.addCarPlate.countLimitDis = false;
            }
        },
        //添加Car Plate 永久有效开关改变函数
        addCarPlateForeverChage(item){
            if(item){
                this.addCarPlate.startTime = "";
                this.addCarPlate.endTime = "";
                this.addCarPlate.isFovever = true;
            }else{
                this.addCarPlate.isFovever = false;
            }
        },
      
        //添加Car Plate配置点击确定执行函数
        addCarPlateSave(){
            let checkCardName = this.$regularCheckLimit(this.addCarPlate.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            // if(this.addCarPlate.carPlate === ""){
            //     this.$message.info(this.$t('CardNumberEmpty'));
            //     return false
            // }
            let checkCarPlate = this.$regularCheckLimit(this.addCarPlate.carPlate,1,64,'PlateNumberEmpty');
            if(!checkCarPlate){
                return false
            }
            let parkingNumberReg = /^[1-9]\d*$/;
            if(!parkingNumberReg.test(this.addCarPlate.payload)){
                this.$message.info(this.$t('ParkingCardNumberLimit'));
                return false
            }else{
                if(Number(this.addCarPlate.payload) < 1 || Number(this.addCarPlate.payload) > 16777215){
                    this.$message.info(this.$t('ParkingCardNumberLimit'));
                    return false
                }
            }

            // if(this.addCarPlate.payload === ""){
            //     this.$message.info(this.$t('ParkingCardNumberLimit'));
            //     return false
            // }
            if(this.addCarPlate.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.addCarPlate.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.addCarPlate.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.addCarPlate.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }

                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.addCarPlate.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                
                finCountLimit = this.addCarPlate.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.addCarPlate.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.addCarPlate.startTime == null){
                    this.addCarPlate.startTime = "";
                }
                if(this.addCarPlate.endTime == null){
                    this.addCarPlate.endTime = "";
                }
                if(this.addCarPlate.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.addCarPlate.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.addCarPlate.startTime != "" && this.addCarPlate.endTime != ""){
                    if(this.addCarPlate.startTime >= this.addCarPlate.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.addCarPlate.startTime;
                finEndTime = this.addCarPlate.endTime;

            }
            let finDevArr = [];
            this.addCarPlate.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            let encryStr = encryptCBC(this.addCarPlate.payload,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            let carNumberEncryStr = encryptCBC(this.addCarPlate.carPlate,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let addUserCarPlateObj = {
                "type": 5,
                "userHouseId":this.updateSiteUser.id,
                // "userId":this.updateSiteUser.userId,
                "checkKeyId": nowTimeTamp, 
                "title": this.addCarPlate.title,
                "carPlate": this.base64ToHex(carNumberEncryStr),
                "payload": this.base64ToHex(encryStr),
                "payloadSha": CryptoJS.SHA256(this.addCarPlate.payload),
                // "cardType": 24,
                "locks": this.addCarPlate.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
                "createTime": nowTimeTamp,
            };
            // console.log("addUserCarPlateObj",addUserCarPlateObj);
            // return false
            const sortedData = Object.keys(addUserCarPlateObj)
                    .sort()
                    .map(key => `${key}=${addUserCarPlateObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('type', 5);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.addCarPlate.title);
            formData.append('carPlate', this.base64ToHex(carNumberEncryStr));
            formData.append('payload', this.base64ToHex(encryStr));
            formData.append('payloadSha', CryptoJS.SHA256(this.addCarPlate.payload));
            // formData.append('cardType', 24);
            formData.append('locks', this.addCarPlate.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('createTime', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            this.addCarPlate.addBtnState = 1;
            sitesUsersApi.addSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('AddSuccessful'));
                    this.addCarPlate.addBtnState = 0;
                    //获取Car Plate 配置列表
                    this.getSiteUserCarPlateList();
                    this.addCarPlate.addCarPlateFrom = false;
                }else{
                    this.addCarPlate.addBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.addCarPlate.addBtnState = 0;
            })
        },
        //Car Plate列表点击编辑
        editCarPlateSetting(item){
            this.editCarPlate.editCarPlateFrom = true;
            let passwordInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let passwordPostObj = {
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":item.entranceKeyId,
                "userId":item.userId,
            }
            sitesUsersApi.getSiteUserCardDetail(passwordInfoObj,passwordPostObj).then(res => {
                if(res.code === 0){
                   this.editCarPlate.title = res.data.title;
                   //将tdk+userHouseId使用SHA256生成AES加密KEY
                   let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
                    //把获取到的16进制的字符串转为base64
                    let carPlateBase64Str = this.hexStringToBase64(res.data.carPlate);
                   //解密之后得到车牌号
                   let carPlateCardNumHex = decryptCBC(carPlateBase64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
                    //    console.log("cardNumHex",cardNumHex)
                   this.editCarPlate.carPlate = carPlateCardNumHex;
                   //把获取到的16进制的字符串转为base64
                   let base64Str = this.hexStringToBase64(res.data.payload);
                    //    console.log("base64Str",res.data.payload,base64Str)
                   //解密之后得到车牌号
                   let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
                    //    console.log("cardNumHex",cardNumHex)
                   this.editCarPlate.payload = cardNumHex;
                   this.editCarPlate.userId = res.data.userId;
                   this.editCarPlate.entranceKeyId = res.data.entranceKeyId;
                   this.editCarPlate.locks = (res.data.locks).split(",");
                   if(res.data.countLimit === 0){
                       this.editCarPlate.countLimit = "";
                       this.editCarPlate.countLimitDis = true;
                       this.editCarPlate.Unlinmited = true;
                   }else{
                       this.editCarPlate.countLimitDis = false;
                       this.editCarPlate.Unlinmited = false;
                       this.editCarPlate.countLimit = res.data.countLimit;
                   }
                   if(res.data.startTime === 0 && res.data.endTime === 0){
                       this.editCarPlate.startTime = "";
                       this.editCarPlate.endTime = "";
                       this.editCarPlate.isFovever = true;
                       this.editCarPlate.fovever = true;
                   }else{
                       this.editCarPlate.startTime = res.data.startTime;
                       this.editCarPlate.endTime = res.data.endTime;
                       this.editCarPlate.isFovever = false;
                       this.editCarPlate.fovever = false;
                   }
                   this.editCarPlate.entranceDeviceList = res.data.entranceDeviceList;
                   this.editCarPlate.devList.map(item=>{
                        item.isChecked = false;
                        if (item.hasOwnProperty('applyStatus')) {
                            delete item.applyStatus
                        }
                    })
                    // console.log("this.editCarPlate.entranceDeviceList",this.editCarPlate.entranceDeviceList)
                    this.editCarPlate.devList.map(item=>{
                        this.editCarPlate.entranceDeviceList.map(item2=>{
                            if(item.id === item2.entranceDeviceId){
                                item.isChecked = true;
                                item.applyStatus = item2.applyStatus;
                            }
                        })
                    })
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
            })
            
        },
        //编辑Car Plate 不限次数开关改变函数
        editCarPlateUnlinmitChage(item){
            if(item){
                this.editCarPlate.countLimit = "";
                this.editCarPlate.countLimitDis = true;
            }else{
                this.editCarPlate.countLimitDis = false;
            }
        },
        //编辑Car Plate 永久有效开关改变函数
        editCarPlateForeverChage(item){
            if(item){
                this.editCarPlate.startTime = "";
                this.editCarPlate.endTime = "";
                this.editCarPlate.isFovever = true;
            }else{
                this.editCarPlate.isFovever = false;
            }
        },

        //编辑Car Plate确认
        editCarPlateSave(){
            let checkCardName = this.$regularCheckLimit(this.editCarPlate.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            let parkingNumberReg = /^[1-9]\d*$/;
            if(!parkingNumberReg.test(this.editCarPlate.payload)){
                this.$message.info(this.$t('ParkingCardNumberLimit'));
                return false
            }else{
                if(Number(this.editCarPlate.payload) < 1 || Number(this.editCarPlate.payload) > 16777215){
                    this.$message.info(this.$t('ParkingCardNumberLimit'));
                    return false
                }
            }
            // if((this.editCarPlate.payload.toString()).trim() === ""){
            //     this.$message.info(this.$t('CardNumberEmpty'));
            //     return false
            // }
            if(this.editCarPlate.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.editCarPlate.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.editCarPlate.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.editCarPlate.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }
                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.editCarPlate.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                finCountLimit = this.editCarPlate.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.editCarPlate.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.editCarPlate.startTime == null){
                    this.editCarPlate.startTime = "";
                }
                if(this.editCarPlate.endTime == null){
                    this.editCarPlate.endTime = "";
                }
                if(this.editCarPlate.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.editCarPlate.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.editCarPlate.startTime != "" && this.editCarPlate.endTime != ""){
                    if(this.editCarPlate.startTime >= this.editCarPlate.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.editCarPlate.startTime;
                finEndTime = this.editCarPlate.endTime;

            }
            let finDevArr = [];
            this.editCarPlate.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            let encryStr = encryptCBC(this.editCarPlate.payload,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let editUserCarPlateObj = {
                "type": 5,
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":this.editCarPlate.entranceKeyId,
                // "checkKeyId": new Date().getTime(), 
                "title": this.editCarPlate.title,
                // "payload": this.base64ToHex(encryStr),
                // "cardType": 24,
                "locks": this.editCarPlate.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
            };
            const sortedData = Object.keys(editUserCarPlateObj)
                    .sort()
                    .map(key => `${key}=${editUserCarPlateObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('entranceKeyId', this.editCarPlate.entranceKeyId);
            formData.append('type', 5);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.editCarPlate.title);
            // formData.append('payload', this.base64ToHex(encryStr));
            // formData.append('cardType', 24);
            formData.append('locks', this.editCarPlate.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            this.editCarPlate.editBtnState = 1;
            sitesUsersApi.updateSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('UpdateSuccessfully'));
                    this.editCarPlate.editBtnState = 0;
                    //获取Car Plate 配置列表
                    this.getSiteUserCarPlateList();
                    this.editCarPlate.editCarPlateFrom = false;
                }else{
                    this.editCarPlate.editBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.editCarPlate.editBtnState = 0;
            })
        },
        //删除Car Plate弹窗
        openDelCarPlateFrom(item){
            this.delCarPlate.delCarPlateFrom = true;
            this.delCarPlate.entranceKeyId = item.entranceKeyId;
        },
        //删除Car Plate 确认
        delCarPlateSetting(){
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            const delSiteUserCarPlateObj = {}
            delSiteUserCarPlateObj.entranceKeyId = [];
            delSiteUserCarPlateObj.entranceKeyId.push(this.delCarPlate.entranceKeyId);
            delSiteUserCarPlateObj.userHouseId = this.updateSiteUser.id;
            delSiteUserCarPlateObj.userId = this.updateSiteUser.userId;
            this.delCarPlate.delBtnState = 1;
            sitesUsersApi.delSiteUserCard(rgnObj,delSiteUserCarPlateObj).then(res => {
                if(res.code === 0){
                    this.delCarPlate.delBtnState = 0;
                    this.$message.success(this.$t('DeleteSuccessfully'));
                    this.delCarPlate.delCarPlateFrom = false;
                    //获取Car Plate 配置列表
                    this.getSiteUserCarPlateList();
                }else{
                    this.delCarPlate.delBtnState = 0;
                    this.$handerrcode(res.code);
                }
                
            }).catch((err) => {
                this.delCarPlate.delBtnState = 0;
                console.log('err', err);
            })
            
        },
    },
    computed:{
        ...mapState(["selectCompany","selectSite"])
    },
    watch:{
      
    }
}
</script>

<style scoped>
.addsiteUersBox{
    display: flex;
}
.addSiteUserLeft{
    width: 50%;
    padding-right: 1vw;
}
.NameBox{
    display: flex;
    justify-content: space-between;
}

.addSiteUserRight{
    width: 50%;
    font-size: 18px !important;
    margin-left: 2vw;
}
.addSiteUserRight p {
    font-size: 16px;
    color: #CFCFCF;
}
.addSiteUserRight p span{
    color: #6498b5;
}
::v-deep .addSiteUserRight .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 100%;
    border: none;
    background: #EFEFEF;
}
.licenseBox{
    background: #EFEFEF;
    margin-top: 1vw;
    padding: 1vw 1vw;
    height: 105px;
    overflow-y: auto;
    border-radius: 10px;
}
.LimitContent{
    border-top:1px solid #ddd;
    /* border-radius: 8px; */
    padding-bottom: 15px;
}
.LimitBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
::v-deep .LimitBox label{
    margin-top: 10px !important;
}
.FoveverBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
.cardText{
    width:48%;
    text-align: right;
    padding-right: 20px; 
    margin-top: 20px;color: #333;
}
::v-deep .el-form-item__label{
    text-align: left;
}
.addCard .el-button--primary {
    margin-left: 60px !important;
    color: #fff;
    background-color: #6498b5;
    border-color: #6498b5;
}
</style>